
import React, { FunctionComponent, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { Draggable, Droppable } from "react-beautiful-dnd";

import { FilterCard } from "./FilterCard";
import { FilterSeparator } from "./FilterSeparator";
import { UpdatePageModel } from "../UpdatePageModel";
import { Button } from 'components';
import { DraggableType } from "enums";
import { IFilter } from "interfaces";
import { BoardContext } from "pages";

interface FiltersListProps {
    canEdit: boolean,
    filters: IFilter[],
    isGlobal: boolean,
    model: UpdatePageModel,
    onEditFilter: (filter: IFilter, isNew: boolean) => void,
    stageId: number,
    stageIndex: number,
}

export const FiltersList: FunctionComponent<FiltersListProps> = function FiltersList(props) {
    const { canEdit, filters, isGlobal, model, onEditFilter, stageId, stageIndex } = props;
    const boardContext = useContext(BoardContext);

    return (<div className="update_filtersList">
        <div className="update_filtersList_label">
            {isGlobal && <>
                <FontAwesomeIcon icon="globe-americas" className="update_card_titleIcon" />
                Global filters:
            </>}
            {!isGlobal && 'Filters:'}
        </div>
        <Droppable
            droppableId={isGlobal ? 'global' : stageId + ''}
            type={DraggableType.Filter}
        >
            {(dropProvided, dropSnapshot) => (
                <div className={cn('update_filtersList_list', {
                    isDraggingFilter: boardContext.isDragging && boardContext.dragType === DraggableType.Filter,
                    empty: filters.length === 0,
                })}>
                    {!isGlobal && (<>
                        <div className="update_card update_filter update_filterGlobal">
                            <div className="update_card_title">
                                <FontAwesomeIcon icon="globe-americas" className="update_card_titleIcon" />
                                Global filters
                            </div>
                        </div>
                        {filters?.length > 0 && (
                            <FilterSeparator />
                        )}
                    </>)}
                    <div
                        ref={dropProvided.innerRef}
                        {...dropProvided.droppableProps}
                        className={cn('update_filtersList_dropContainer', {
                            isDraggingOver: dropSnapshot.isDraggingOver,
                        })}
                    >
                        {filters && filters.map((f, i) => (
                            <Draggable
                                draggableId={model.getDragDropId(DraggableType.Filter, f.id)}
                                key={'filter_' + f.id}
                                index={i}
                                isDragDisabled={!canEdit}
                            >
                                {(dragProvided, dragSnapshot) => (
                                    <div
                                        className="update_filtersList_filterWrap"
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                    >
                                        <FilterCard
                                            canEdit={canEdit}
                                            dragProvided={dragProvided}
                                            dragSnapshot={dragSnapshot}
                                            filter={f}
                                            isGlobal={isGlobal}
                                            model={model}
                                            onEditFilter={onEditFilter}
                                            stageId={stageId}
                                            stageIndex={stageIndex}
                                        />
                                        {i !== filters.length - 1 && (
                                            <FilterSeparator />
                                        )}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {dropProvided.placeholder}
                    </div>
                    {canEdit && (
                        <Button
                            className={cn('update_addFilterButton', {
                                isDragging: false,
                            })}
                            theme="blueOutline"
                            size="small"
                            onClick={() => onEditFilter(model.createDefaultFilter(), true)}
                        >
                            Add filter
                        </Button>
                    )}
                </div>
            )}
        </Droppable>
    </div>);
}